// Copyright (c) 2026 aiApas LLC. All Rights Reserved.
// GuardRok — Proprietary and Confidential. Patent Pending.
// Unauthorized use or distribution is prohibited.

import { createClient } from "@supabase/supabase-js"
import { SUPABASE_URL, SUPABASE_ANON_KEY } from "./config"

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
